import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-section" }
const _hoisted_2 = {
  target: "_blank",
  href: "https://memories.gallery/hw-transcoding/"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$options.title), 1),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.t(
          'memories',
          'Memories uses the go-vod transcoder. You can run go-vod exernally (e.g. in a separate Docker container for hardware acceleration) or use the built-in transcoder. To use an external transcoder, enable the following option and follow the instructions in the documentation:',
        )) + " ", 1),
      _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t('memories', 'External Link')), 1),
      (_ctx.status && _ctx.enableTranscoding)
        ? (_openBlock(), _createBlock(_component_NcNoteCard, {
            key: 0,
            type: _ctx.binaryStatusType(_ctx.status.govod)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.binaryStatus('go-vod', _ctx.status.govod)), 1)
            ]),
            _: 1
          }, 8, ["type"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.vod.external'],
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config['memories.vod.external']) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('memories.vod.external')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable external transcoder')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcTextField, {
        disabled: !_ctx.enableTranscoding,
        label: _ctx.t('memories', 'Binary path (local only)'),
        "label-visible": true,
        "model-value": _ctx.config['memories.vod.path'],
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update('memories.vod.path', $event.target.value)))
      }, null, 8, ["disabled", "label", "model-value"]),
      _createVNode(_component_NcTextField, {
        disabled: !_ctx.enableTranscoding,
        label: _ctx.t('memories', 'Bind address (local only)'),
        "label-visible": true,
        "model-value": _ctx.config['memories.vod.bind'],
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('memories.vod.bind', $event.target.value)))
      }, null, 8, ["disabled", "label", "model-value"]),
      _createVNode(_component_NcTextField, {
        disabled: !_ctx.enableTranscoding,
        label: _ctx.t('memories', 'Connection address (same as bind if local)'),
        "label-visible": true,
        "model-value": _ctx.config['memories.vod.connect'],
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.update('memories.vod.connect', $event.target.value)))
      }, null, 8, ["disabled", "label", "model-value"]),
      _createVNode(_component_NcTextField, {
        type: "number",
        min: "15",
        max: "45",
        placeholder: "25",
        disabled: !_ctx.enableTranscoding,
        label: _ctx.t('memories', 'Quality Factor (15 - 45) (default 25)'),
        "label-visible": true,
        "model-value": String(_ctx.config['memories.vod.qf']),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.update('memories.vod.qf', Number($event.target.value))))
      }, null, 8, ["disabled", "label", "model-value"])
    ])
  ]))
}